// Datos compartidos del front de Teatro.
// Mientras no exista la DB, todas las vistas (landing, detalle y reserva)
// cargan la MISMA información desde aquí. Cuando se conecte el backend,
// basta con reemplazar estas constantes / getShowById por llamadas a la API.

export const defaultVideoUrl = "https://www.youtube.com/watch?v=dQw4w9WgXcQ";

export const genres = [
  {
    name: "DRAMA",
    tag: "Pasión y emoción",
    url: "/genero/drama/",
    image:
      "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=1200&auto=format&fit=crop&q=80",
  },
  {
    name: "COMEDIA",
    tag: "Humor y risa",
    url: "/genero/comedia/",
    image:
      "https://images.unsplash.com/photo-1501891831523-1a91160fd8e2?w=1200&auto=format&fit=crop&q=80",
  },
  {
    name: "MUSICALES",
    tag: "Show en vivo",
    url: "/genero/musicales/",
    image:
      "https://images.unsplash.com/photo-1489515217757-5fd1be406fef?w=1200&auto=format&fit=crop&q=80",
  },
  {
    name: "TEATRO INFANTIL",
    tag: "Familia y magia",
    url: "/genero/teatro-infantil/",
    image:
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1200&auto=format&fit=crop&q=80",
  },
  {
    name: "STAND UP",
    tag: "Monólogos",
    url: "/genero/stand-up/",
    image:
      "https://images.unsplash.com/photo-1489515217757-5fd1be406fef?w=1200&auto=format&fit=crop&q=80&sat=-20",
  },
  {
    name: "TEATRO CAPACITACIÓN",
    tag: "Formación",
    url: "/genero/teatro-capacitacion/",
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&auto=format&fit=crop&q=80",
  },
];

// Estructura base de obras por género (sin id todavía).
const rawGenreShows = {
  DRAMA: [
    {
      title: "LA ÚLTIMA FUNCIÓN",
      image: "https://images.unsplash.com/photo-1503095396549-807759245b35?w=400&auto=format&fit=crop&q=80",
      description: "Drama contemporáneo sobre decisiones, familia y segundas oportunidades.",
      videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    },
    {
      title: "SILENCIO EN ESCENA",
      image: "https://images.unsplash.com/photo-1515169067868-5387ec356754?w=400&auto=format&fit=crop&q=80",
      description: "Montaje íntimo para teatros y eventos culturales de formato medio.",
    },
    {
      title: "CARTAS AL VIENTO",
      image: "https://images.unsplash.com/photo-1507924538820-ede94a04019d?w=400&auto=format&fit=crop&q=80",
      description: "Historia emocional con música en vivo y puesta minimalista.",
    },
    {
      title: "LA CASA VACÍA",
      image: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=400&auto=format&fit=crop&q=80",
      description: "Obra dramática para públicos adultos con gran impacto visual.",
    },
  ],
  COMEDIA: [
    {
      title: "DE UNO A DIEZ CUÁNTO ME QUIERES",
      image: "https://images.unsplash.com/photo-1521572267360-ee0c2909d518?w=400&auto=format&fit=crop&q=80",
      description: "Comedia familiar con ritmo dinámico y participación del público.",
    },
    {
      title: "NO ME DEJE HABLANDO SOLO",
      image: "https://images.unsplash.com/photo-1521119989659-a83eee488004?w=400&auto=format&fit=crop&q=80",
      description: "Stand-up teatral sobre la vida en pareja y malentendidos cotidianos.",
    },
    {
      title: "OBRA SIN IMAGEN ASOCIADA",
      image: "/static/img/logo_ppal.png",
      description: "Formato íntimo para eventos privados y funciones corporativas.",
    },
    {
      title: "TRES ESPÉRIMOS DESODIDENTES",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&auto=format&fit=crop&q=80",
      description: "Comedia de personajes con improvisación y momentos musicales.",
    },
  ],
  MUSICALES: [
    {
      title: "NOCHE DE BROADWAY LATINO",
      image: "https://images.unsplash.com/photo-1489515217757-5fd1be406fef?w=400&auto=format&fit=crop&q=80",
      description: "Repertorio de musicales con voces en vivo y coreografías dinámicas.",
    },
    {
      title: "RITMO DE BARRIO",
      image: "https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&auto=format&fit=crop&q=80",
      description: "Montaje musical juvenil ideal para festivales y eventos masivos.",
    },
    {
      title: "CANTAR Y CONTAR",
      image: "https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=400&auto=format&fit=crop&q=80",
      description: "Espectáculo familiar que combina teatro, canto y humor.",
    },
    {
      title: "ESCENARIO ELÉCTRICO",
      image: "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=400&auto=format&fit=crop&q=80",
      description: "Show de alto impacto con luces, banda y elenco ampliado.",
    },
  ],
  "TEATRO INFANTIL": [
    {
      title: "EL BOSQUE MÁGICO",
      image: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400&auto=format&fit=crop&q=80",
      description: "Aventura participativa para niños con personajes fantásticos.",
    },
    {
      title: "CAPITÁN SONRISA",
      image: "https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=400&auto=format&fit=crop&q=80",
      description: "Obra interactiva para colegios, cajas de compensación y municipios.",
    },
    {
      title: "EL RELOJ DE COLORES",
      image: "https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=400&auto=format&fit=crop&q=80&sat=20",
      description: "Montaje didáctico con canciones y aprendizaje emocional.",
    },
    {
      title: "PLANETA JUGUETE",
      image: "https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=400&auto=format&fit=crop&q=80&hue=20",
      description: "Propuesta escénica colorida para público infantil y familiar.",
    },
  ],
  "STAND UP": [
    {
      title: "MICRÓFONO ABIERTO",
      image: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=400&auto=format&fit=crop&q=80",
      description: "Rutina de comedia ágil con interacción directa con el público.",
    },
    {
      title: "NOCHE DE MONÓLOGOS",
      image: "https://images.unsplash.com/photo-1518976024611-28bf4b48222e?w=400&auto=format&fit=crop&q=80",
      description: "Show de humor para eventos empresariales y privados.",
    },
    {
      title: "SIN FILTRO",
      image: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=400&auto=format&fit=crop&q=80",
      description: "Comedia de observación cotidiana en formato íntimo.",
    },
    {
      title: "RISAS EN CADENA",
      image: "https://images.unsplash.com/photo-1507874457470-272b3c8d8ee2?w=400&auto=format&fit=crop&q=80",
      description: "Especial de stand-up para activaciones de marca y festivales.",
    },
  ],
  "TEATRO CAPACITACIÓN": [
    {
      title: "LIDERAZGO EN ESCENA",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&auto=format&fit=crop&q=80",
      description: "Teatro aplicado a habilidades blandas para equipos corporativos.",
    },
    {
      title: "COMUNICACIÓN EFECTIVA",
      image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&auto=format&fit=crop&q=80",
      description: "Workshop escénico para mejorar presentación y manejo de audiencias.",
    },
    {
      title: "SERVICIO CON ACTITUD",
      image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=400&auto=format&fit=crop&q=80",
      description: "Entrenamiento teatral para equipos de atención al cliente.",
    },
    {
      title: "TRABAJO EN EQUIPO 360",
      image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=400&auto=format&fit=crop&q=80",
      description: "Dinámicas inmersivas para fortalecer colaboración y cultura.",
    },
  ],
};

// Asignamos un id secuencial y estable a cada obra (mismo orden siempre),
// para poder navegar por URL: /obra/<id>/ y /reservar/<id>/.
let _seq = 0;
export const genreShows = Object.fromEntries(
  Object.entries(rawGenreShows).map(([genreName, shows]) => [
    genreName,
    shows.map((show) => ({ ...show, id: ++_seq, genre: genreName })),
  ])
);

// Lista plana de todas las obras (referencia a los mismos objetos con id).
export const allShows = Object.values(genreShows).flat();

// Ficha compartida. Mientras no haya DB, es la misma para todas las obras.
export const detailContent = {
  synopsis:
    "Esta es una obra de formato versátil ideal para eventos corporativos, festivales y temporadas culturales. El montaje combina humor, emoción y una puesta escénica adaptable a diferentes espacios.",
  facts: [
    { label: "COMPAÑÍA", value: "Somos Teatro Producciones" },
    { label: "DURACIÓN", value: "45 minutos" },
    { label: "PÚBLICO", value: "Familiar / Empresarial" },
    { label: "FORMATO", value: "Presencial" },
    { label: "ELENCO", value: "4 actores" },
  ],
};

// Devuelve la obra por id. Si no existe (o aún no conectamos DB),
// cae en la primera para que la vista siempre cargue la misma información.
export function getShowById(id) {
  return allShows.find((s) => String(s.id) === String(id)) || allShows[0];
}
